// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDk_8yN0lfUq2vjsj6DSI0Wp2eilQ7YU4c",
  // authDomain: "playballhog-aa0fc.firebaseapp.com",
  authDomain: "localhost",
  projectId: "playballhog-aa0fc",
  storageBucket: "playballhog-aa0fc.firebasestorage.app",
  messagingSenderId: "718373922050",
  appId: "1:718373922050:web:1d7edad6378f8f7be78e1b",
  measurementId: "G-03ZL441C3K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);

export { auth, RecaptchaVerifier, signInWithPhoneNumber };